// jQuery
jQuery(function ($) {
    $(".answer").css("display", "none");
    // 質問の答えをあらかじめ非表示



    //質問をクリック
    $(".question").click(function () {

        $(".question").not(this).removeClass("_open");
        //クリックしたquestion以外の全てのopenを取る

        $(".question").not(this).next().slideUp(300);
        //クリックされたquestion以外のanswerを閉じる

        $(this).toggleClass("_open");
        //thisにopenクラスを付与

        $(this).next().slideToggle(300);
        //thisのanswerを展開、開いていれば閉じる

    });
});

function showElementAnimation() {

    var element = document.getElementsByClassName('js-animation');
    if (!element) return; // 要素がなかったら処理をキャンセル

    var showTiming = window.innerHeight > 768 ? 200 : 40; // 要素が出てくるタイミングはここで調整
    var scrollY = window.pageYOffset;
    var windowH = window.innerHeight;

    for (var i = 0; i < element.length; i++) {
        var elemClientRect = element[i].getBoundingClientRect();
        var elemY = scrollY + elemClientRect.top;
        if (scrollY + windowH - showTiming > elemY) {
            element[i].classList.add('is-show');
        } else if (scrollY + windowH < elemY) {
            // 上にスクロールして再度非表示にする場合はこちらを記述
            element[i].classList.remove('is-show');
        }
    }
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);